import { Payeer } from './pay';
import { CloudPay } from './cloudpay';
import { Robokassa } from './robokassa';

/**
 * Process payment response from backend
 * @param {Object} vue - Vue instance (this)
 * @param {Object} response - Response from Payment.save()
 * @param {Function} onSuccess - Callback on successful payment initiation
 * @param {Function} onError - Callback on error
 */
export function processPayment(vue, response, onSuccess, onError) {
    const data = response.body;

    if (data.errors) {
        if (onError) {
            onError(data.errors);
        }
        return;
    }

    switch (data.vendor) {
        case 'unitpay':
            window.location.href = data.redirect_url;
            break;
        case 'payeer':
            Payeer(data);
            break;
        case 'cloudpay':
            CloudPay(data);
            break;
        case 'rbkassa':
            Robokassa(data);
            break;
        default:
            if (onError) {
                onError({ general: ['Unknown payment vendor'] });
            } else {
                alert('Unknown payment vendor');
            }
    }

    if (onSuccess) {
        onSuccess(data);
    }
}

/**
 * Make payment request and process response
 * @param {Object} vue - Vue instance (this)
 * @param {Number} amount - Payment amount
 * @param {Number} systemId - Payment system ID
 * @param {Object} options - Additional options (product_item_id, balance_used, etc.)
 * @returns {Promise}
 */
export function makePayment(vue, amount, systemId, options = {}) {
    const payload = {
        amount,
        system: systemId,
        ...options
    };

    return vue.$services.Payment().save(payload).then(resp => {
        return new Promise((resolve, reject) => {
            processPayment(
                vue,
                resp,
                (data) => resolve(data),
                (errors) => reject(errors)
            );
        });
    });
}
